import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("norea_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const company = localStorage.getItem("norea_company");
  if (company) config.headers["X-Company"] = company;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403 && String(err?.response?.data?.detail || "").startsWith("Société non autorisée") && localStorage.getItem("norea_company")) {
      localStorage.removeItem("norea_company");
      window.location.reload();
    }
    if (err?.response?.status === 401) {
      localStorage.removeItem("norea_token");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
